import React, {useState} from 'react'
import {IconButton, Tooltip} from '@mui/material'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import {useTranslation} from 'react-i18next'
import SendEmailComposeDialog from './SendEmailComposeDialog'

const SendEmailAction = ({size = 'medium'}) => {
    const {t} = useTranslation()
    const [open, setOpen] = useState(false)

    return (
        <>
            <Tooltip title={t('send_email.title')}>
                <IconButton onClick={() => setOpen(true)} size={size}>
                    <AddRoundedIcon />
                </IconButton>
            </Tooltip>
            <SendEmailComposeDialog open={open} onClose={() => setOpen(false)} />
        </>
    )
}

export default SendEmailAction
